export const en = {
    'two-fa-banner-title': 'Two-factor authentication required soon',
    'two-fa-banner-text':
        'For security reasons, two-factor authentication (2FA) will soon become mandatory for all developers. Please enable it in your Yandex ID settings.',
    'two-fa-banner-link': 'Enable 2FA',
} as const;
export const ru = {
    'two-fa-banner-title': 'Скоро двухфакторная аутентификация станет обязательной',
    'two-fa-banner-text':
        'В целях безопасности для всех разработчиков скоро станет обязательной двухфакторная аутентификация (2FA). Пожалуйста, включите её в настройках Яндекс ID.',
    'two-fa-banner-link': 'Включить 2FA',
} as const;
